import wechat from 'weixin-js-sdk'
import { nowTimestamp } from '@/utils'
import { sendMessageOnlyFrontEnd } from '@/utils/message_send'
import { MESSAGE_NAME } from '@/constants/message'

const RECORDING_STATUS = {
    'END': 0,
    'CANCELING': -1,
    'DOING': 1
}


const FOOTER_MAIN_HEIGHT = 52
const RECORDING_TIPS_HEIGHT = 40
const DELAY_RECORD = 200 // touchstart 时延迟一定时间后才调用录音方法
const RECORD_DURATION_MIN = 1000

export default {
    data () {
        return {
            isRecordAuth: false,
            recordingStatus: RECORDING_STATUS.END,
            startRecordTimer: null,
            recordStartTime: 0
        }
    },
    computed: {
        isVoiceRecording () {
            return [
                RECORDING_STATUS.DOING,
                RECORDING_STATUS.CANCELING
            ].includes(this.recordingStatus)
        },
        voiceInputPlacehoder () {
            if (this.isVoiceRecording) {
                if (this.recordingStatus === RECORDING_STATUS.CANCELING) {
                    return '松开 取消'
                } else {
                    return '松开 结束'
                }
            } else {
                return '按住 说话'
            }
        }
    },
    watch: {
        isVoiceRecording () {
            this.$eventBus.setGlobalVoiceStatus(this.isVoiceRecording)
        },
        isWechatJSSDKReady (value) {
            /**
             * 监听录音自动停止接口
             * 录音时间超过一分钟没有停止的时候会执行 complete 回调
             * todo: 多次调用，是否只触发一次？
             */
            if (value) {
                wechat.onVoiceRecordEnd({
                    // eslint-disable-next-line no-unused-vars
                    complete: ({ localId }) => {
                        /**
                         * todo:
                         * 需要测试该方法内的 wx.stopRecord()
                         * 是否还能触发 success 回调
                         */
                        this.endVoiceRecording()
                    }
                })
            }
        }
    },
    methods: {
        // 获取录音授权
        getRecordAuth (success) {
            wechat.startRecord({
                success: () => {
                    wechat.stopRecord()
                    if (typeof success === 'function') {
                        success()
                    }
                },
                cancel () {
                    this.$toast.fail('如不允许，将无法使用语音')
                },
                fail () {
                    this.$toast.fail('录音权限被禁止，请在 设置 -> 隐私 -> 授权管理 中开启')
                }
            })
        },
        startVoiceRecording () {
            this.$audioPlayer.stop()
            this.$videoPlayer.close()
            this.recordingStatus = RECORDING_STATUS.DOING

            this.startRecordTimer = setTimeout(
                realStartVoiceRecording.bind(this),
                DELAY_RECORD
            )

            function realStartVoiceRecording () {
                this.startRecordTimer = null
                wechat.startRecord({
                    success: () => {
                        this.recordStartTime = nowTimestamp()
                    },
                    fail: (err) => {
                        // eslint-disable-next-line
                        console.error(err)
                        this.recordingStatus = RECORDING_STATUS.END
                    }
                })
            }
        },
        endVoiceRecording () {
            const onEndRecordingStatus = this.recordingStatus // 手指放开时的状态

            this.recordingStatus = RECORDING_STATUS.END

            if (this.startRecordTimer) {
                this.clearVoiceTimer()
                return
            }

            if (onEndRecordingStatus === RECORDING_STATUS.CANCELING) { // 录音取消
                wechat.stopRecord()
                return
            }

            const recordDuration = nowTimestamp() - this.recordStartTime

            if (recordDuration < RECORD_DURATION_MIN) {
                this.$toast.fail('说话时间太短')
                wechat.stopRecord()
                return
            }

            wechat.stopRecord({
                success: ({ localId }) => {
                    sendMessageOnlyFrontEnd({
                        type: 'base',
                        detailType: MESSAGE_NAME.AUDIO,
                        content: {
                            localId,
                            duration: (recordDuration / 1000) // 单位秒
                        }
                    })
                    /**
                     * 语音转文字放在了 audio 消息组件的 Mixin 处理
                     * 原因：
                     * 1. 尽管 eventBus $emit 时同步操作，但取不到返回值（主要是 messageId 字段），
                     *    需要此字段才能保证转文字后的消息放在语音消息的后一位
                     * 2. 对于服务器推过来的语音消息以后也许也需要转文字
                     */
                }
            })
        },
        detectCancelVoiceRecording (event) {
            const cancelY = this.$eventBus.windowHeight - FOOTER_MAIN_HEIGHT - RECORDING_TIPS_HEIGHT
            const curY = event.targetTouches[0].clientY

            this.recordingStatus = cancelY > curY
                ? RECORDING_STATUS.CANCELING
                : RECORDING_STATUS.DOING
        },
        clearVoiceTimer () {
            if (this.startRecordTimer) {
                clearTimeout(this.startRecordTimer)
                this.startRecordTimer = null
            }
        }
    },
    beforeDestroy () {
        this.clearVoiceTimer()
    }
}
